export class SuccessBody {   
    title : string;
    current_icon : string = "./assets/img/modal_v2/exito.png";
    message : string;  
    embebed_message: string;  
    info_message_top : string; // AZUL aparece arriba del mensaje principal
    info_message : string; // AZUL aparece debajo del mensaje principal
    main_button : string; 
    secondary_button : string;
    text_align : string;  // text-center, text-left, text-right
    list_space: string; // mb-1, mb-2, mb-3
    list_content : string[];  //array de strings
    link_message: string;
    onMainAction : () => void;
    onSecondaryAction : () => void;
    onLinkAction : () => void;
    width: string = '350px';
    height: string = '80vh';
    button_align: string = 'text-center';
    mainButtonClass: string;
    secondaryButtonClass: string;
}


// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/modal/model/success_body.ts